var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.717 26.444 9.73 7.298a1.621 1.621 0 1 0 1.947-2.595l-9.01-6.82V10.542a1.621 1.621 0 1 0-3.243 0v14.596c0 .539.225 1.024.576 1.306z",
    fill: "#479FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.574 0C15.703 0 5.565 8.568 3.587 20.273l-.617-.916a1.623 1.623 0 1 0-2.692 1.816l3.244 4.866c.267.405.701.67 1.184.721h.162c.43-.001.84-.173 1.143-.478l4.055-4.055a1.623 1.623 0 0 0-2.295-2.295l-1.006 1.014c1.868-11.494 12.7-19.297 24.192-17.43 11.494 1.868 19.298 12.7 17.43 24.193-1.658 10.206-10.473 17.704-20.813 17.702a19.957 19.957 0 0 1-16.519-8.239 1.622 1.622 0 1 0-2.643 1.882 23.168 23.168 0 0 0 19.162 9.601c13.436 0 24.327-10.891 24.327-24.328C51.901 10.891 41.01 0 27.574 0z",
    fill: "#479FCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0d09bb61f2a8eec40acd195768ea0bb4.svg";
export { ForwardRef as ReactComponent };